import React from 'react';
import { Link } from 'react-router-dom';


export const PageNotFound = () => {
    const isLogin=localStorage.getItem('isLoginTAC')==='true'?true:false;
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="text-center">
                <h1 className="">404 - Not Found</h1>
                <p className="">The page you are looking for does not exist.</p>
                <Link to={isLogin?"/users" :"/" } >Go to Home Page</Link>
            </div>
        </div>
    );
}